import male_beruda_short from "./male_bermuda_shorts.png";
import male_blue_shirt from "./male_blue_shirt.png";
import male_flip_flops from "./male_flip_flops.png";
import male_oxxo_shirt from "./male_oxxo_shirt.png";
import male_pants from "./male_pants.png";
import male_sandals from "./male_sandals.png";
import male_shirt from "./male_shirt.png";
import male_shoes from "./male_shoes.png";
import male_shorts from "./male_shorts.png";

import female_heels from "./Female Heels.png";
import female_oxxo_shirt from "./Female oxxo shirt.png";
import female_pants from "./Female pants.png";
import female_sandals from "./Female sandals.png";
import female_shirt from "./Female shirt.png";
import female_shoes from "./Female shoes.png";
import female_short from "./Female short.png";
import female_skirt from "./Female skirt.png";
import female_top from "./Female top.png";

import female_siluet from "./female-siluet.png";
import male_siluet from "./male-siluet.png";

export const imgclothes = {
	male_beruda_short,
	male_blue_shirt,
	male_flip_flops,
	male_oxxo_shirt,
	male_pants,
	male_sandals,
	male_shirt,
	male_shoes,
	male_shorts,
	female_siluet,
	male_siluet,
	female_heels,
	female_oxxo_shirt,
	female_pants,
	female_sandals,
	female_shirt,
	female_shoes,
	female_short,
	female_skirt,
	female_top,
};
